import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SiteLayout from './components/SiteLayout';
import ActivReward from './components/ActivReward/';
// import EMCVerificationPortalWithRouter from './components/EMC/';
import CorporateDashboard from './components/CorporateDashboard/';
import CorporateDashboardLogin from './components/CorporateDashboard/Login';
import RequireCorpAuth from './components/CorporateDashboard/RequireCorpAuth';

function App() {
  return (
      <BrowserRouter basename="/web">
        <Routes>
          <Route path='/corporate-dashboard/login' element={<CorporateDashboardLogin />} />
          <Route path='/corporate-dashboard' element={<RequireCorpAuth><CorporateDashboard /></RequireCorpAuth>} />

          <Route element={<SiteLayout />}>
            <Route index element={<></>} />
            <Route path='/activ-reward' element={<ActivReward />} />
            {/* <Route path='/e-mc' element={<EMCVerificationPortalWithRouter/>}></Route>
            <Route path='/e-mc/:reference_id' element={<EMCVerificationPortalWithRouter/>}></Route> */}
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
